/*
 * @Description: 未支付-部分支付
 * @Date: 2020-12-12 17:44:29
 */
import fields from './fields';
import { projectPriceHanderl } from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import {
  listNoPayOrderPeopleAndSupplie,
  totalNoPayOrderPeopleAndSupplie
} from '@/api/ajax';

let example = new TableRenderClass({ fields, search });

// 页面入口
const part = example.createPart({
  name: '订单详情',
  search: [
    'orderNo',
    'projectName',
    'createDate',
    'payStatus',
    'fullName',
    'phone',
    'supplierId'
  ],
  list: listNoPayOrderPeopleAndSupplie,
  requestNow: true,
  fields: [
    'index',
    'orderNo',
    'payProjectStructureType',
    'payee',
    'userPhone',
    'projectName',
    'createDate',
    'finishSum',
    'taskPrice',
    'finishSumTaskPrice',
    projectPriceHanderl(2),
    'payStatus03',
    'finishPayDt',
    'endPointFinishPayDt',
    'download'
  ]
});

// individualAjax 为独立注册字段，用于获取总价接口
export default {
  name: '订单详情',
  childMenu: [{ ...part, individualAjax: totalNoPayOrderPeopleAndSupplie }]
};
